import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useQuery } from '@tanstack/react-query';

export const useClient = ({ id }: { id?: string }) => {
  const { data: client, isLoading } = useQuery({
    queryKey: ['client.get', id],
    queryFn: () => {
      if (!id) return undefined;
      return ClientsClient.get(id);
    },
    enabled: !!id,
  });

  return {
    client,
    isLoading,
  };
};
